
// export default () => ({
    
// })
export default () => ({
    period: null,
    currentPeriod: null,
    weeks: null,
    specialWeeks: null
})